import { coreRoutes } from '../../core/config/routes/routes';
import { erpRoutes } from '../../erp/config/routes/routes';

export const routes = {
  ...coreRoutes,
  ...erpRoutes,
  admin: {
    ...coreRoutes.admin,
    ...erpRoutes.admin,
  },
  auth: {
    ...coreRoutes.auth,
    ...erpRoutes.auth,
  },
};
